import React from "react";

const sections = [
  {
    title: "Other Service",
    instruments: [
      "Sales and Repairing service all types of instruments Lab and Plant both",
      "Sales and service all types of Glasswares As per customer’s requirements.",
    ],
    images: ["oser1.png", "oser2.png", "oser3.png", "oser4.png", "oser5.png"],
  },
];

const OtherService = () => {
  return (
    <section className="bg-gray-100 text-gray-800 py-12 px-4 md:px-12">
      {/* Page Title */}
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold border-b-4 inline-block border-orange-500 pb-2">
          Other Service
        </h2>
      </div>

      {sections.map((section, idx) => (
        <div
          key={idx}
          className="bg-white shadow-lg rounded-xl p-6 md:p-8 mb-10"
        >
          <div className="flex flex-col md:flex-row gap-8">
            {/* LEFT: Content */}
            <div className="md:w-1/2">
              <h3 className="text-2xl font-bold text-orange-600 flex items-center gap-2 mb-2">
                <span className="text-3xl">❖</span>
                {section.title}
              </h3>
              {section.subtitle && (
                <p className="text-gray-600 font-medium mb-4">
                  {section.subtitle}
                </p>
              )}

              <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
                {section.instruments.map((item, i) => (
                  <div
                    key={i}
                    className="font-bold border border-orange-200 rounded-lg px-4 py-2 text-sm hover:bg-orange-100 transition shadow-sm"
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT: Image Gallery */}
            {section.images && (
              <div className="md:w-1/2 grid grid-cols-2 gap-4">
                {section.images.map((img, i) => (
                  <div
                    key={i}
                    className="bg-gray-100 p-2 rounded-lg shadow-md hover:scale-105 transform transition duration-300"
                  >
                    <img
                      src={`./img/service/${img}`}
                      alt={`${section.title} ${i + 1}`}
                      className="w-full h-40 object-contain"
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </section>
  );
};

export default OtherService;
